const VOWELS = ['a', 'e', 'i', 'o', 'u']

export const getPluralFromSingular = (singular: string): string => {
  if (['ch', 'sh'].includes(singular.substr(-2, 2))) return singular + 'es'

  if (['s', 'x', 'z'].includes(singular.substr(-1, 1))) return singular + 'es'

  if (VOWELS.includes(singular.substr(-2, 1)) && singular.substr(-1, 1) === 'y')
    return singular + 's'

  if (
    !VOWELS.includes(singular.substr(-2, 1)) &&
    singular.substr(-1, 1) === 'y'
  )
    return singular.substr(0, singular.length - 1) + 'ies'

  if (singular.substr(-2, 2) === 'fe')
    return singular.substr(0, singular.length - 2) + 'ves'

  if (
    !VOWELS.includes(singular.substr(-2, 1)) &&
    singular.substr(-1, 1) === 'o'
  )
    return singular + 'es'

  return singular + 's'
}

/**
 * Utility for reporting counts, which manages pluralization based on count.
 *
 * @param {Object} args The main arguments object.
 * @param {number} [args.count=0] The number of args.noun
 * @param {string} args.singular A singular noun, will be automatically pluralized when necessary.
 * @param {string} [args.plural] Manually supply the plural version of the noun.
 * @param {string} [args.hideCount=false] Return only the noun, no count
 *
 * @returns {String} Returns a formatted string.
 *
 * @example
 *
 * pluralize({ count: 1, singular: 'loan' })
 * // => 1 loan
 *
 */

const pluralize = ({
  count = 0,
  singular,
  plural = '',
  hideCount = false,
}: {
  count: number
  singular: string
  plural?: string
  hideCount?: boolean
}): string => {
  const finalNoun = (() => {
    const isPlural = count !== 1

    if (isPlural) return plural || getPluralFromSingular(singular)
    else return singular
  })()

  if (hideCount) return finalNoun

  return `${count} ${finalNoun}`
}

export default pluralize
